import { Map } from 'immutable';

import { replaceOperation } from '../../product/operations';
import { editMaterials } from '../materials';
import { tagsFromArray } from '../../tags';

import { ATTRIBUTE } from '../../../constants/attributes';
import { VALUE } from '../../../constants/product';
import { EMPTY } from '../../../constants';
import { FORM } from '../../../constants/forms';

export function materials({ operation, product, ...rest }) {
  const updates = editMaterials({
    operation: operation.get('type'),
    product: product.setIn([FORM.DETAILS, ATTRIBUTE.MATERIALS], Map({ [VALUE]: tagsFromArray(operation.get('value')) })),
  });

  return {
    ...rest,
    product: updates.product = updates.product.set('operations',
      updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
    ),
  };
}
